export default () => {
    return [
        'Alphaville',
        'Carioca Engenharia',
        'CIPA',
        'Estasa',
        'Estácio',
        'Lowndes',
        'Multiplan',
        'Vasco',
        'Cassi',
        'Fasano',
        'Flamengo',
        'Icatu',
        'Leroy Merlin',
        'Renner',
        'Shopping da Gávea',
        'Shopping Nova América',
        'Citta',
        'Fundação Bradesco',
        'Hydronorth',
        'Marriott',
        'Papelex',
        'Saint Gobain',
        'Shopping Fashion Mall',
        'Viapol'
    ];
};
